import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import { useParams } from "react-router";
import type { RoleStatuses } from "~enums/roleStatuses";
import type { Roles } from "~enums/roles";
import { useApi } from "./useApi";

type AddRole = {
  personId: string;
  role: Roles;
  status?: RoleStatuses;
  seasonId: string | null;
  entityId?: string;
  fixtureId?: string;
};

export const useAddRole = (options: UseMutationOptions<unknown, unknown, AddRole, unknown> = {}) => {
  const { sport, organizationId } = useParams();
  const request = useApi();

  if (!organizationId || !sport) {
    throw new Error(
      `OrganizationId or sport not found in route params. organizationId: ${organizationId}, sport: ${sport}`,
    );
  }

  return useMutation({
    mutationFn: (body: AddRole) => request(`${sport}/o/${organizationId}/roles`, { method: "POST", body }),
    ...options,
  });
};
